import type { BrowserQuote } from './types';

function resolvedText(q: BrowserQuote): string {
  return q.editedText ?? q.text;
}

function csvEscape(value: string): string {
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function formatQuotesForClipboard(quotes: BrowserQuote[], title: string): string {
  const header = title ? `Quotes from "${title}"` : 'Quotes';
  const blocks = quotes.map((q) => {
    const attribution = q.speaker ? ` — ${q.speaker}` : '';
    return `"${resolvedText(q)}"${attribution}\n  (score ${q.score})`;
  });
  return [header, '', ...blocks].join('\n');
}

export function quotesToCsv(quotes: BrowserQuote[], title: string): string {
  const rows: string[] = [];
  rows.push(['quote', 'score', 'rationale', 'speaker', 'position', 'source_title'].join(','));
  for (const q of quotes) {
    rows.push(
      [
        csvEscape(resolvedText(q)),
        String(q.score),
        csvEscape(q.rationale),
        csvEscape(q.speaker ?? ''),
        String(q.position),
        csvEscape(title),
      ].join(','),
    );
  }
  return rows.join('\n');
}

export function quotesToTxt(quotes: BrowserQuote[], title: string): string {
  return formatQuotesForClipboard(quotes, title);
}

export function downloadAsFile(content: string, filename: string, mimeType: string): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
